import Button from '@zeptonow/zui/Button';
import Typography from '@zeptonow/zui/Typography';
import { useNavigate } from 'react-router-dom';
import { DeclarationConstants } from '../constants/global';
import { generateImage } from '../utilities/utils';

const PageNotFoundView = () => {
  const naviagte = useNavigate();

  return (
    <div className="flex flex-col justify-center items-center text-gray-700 h-[calc(100vh-4rem)]">
      {generateImage({
        name: 'assets/404.png',
        fullSource: true,
        alt: 'not found image',
        className: '!h-56 !w-56 mr-5',
      })}
      <Typography variant={'h5'} className="!mb-2">
        {DeclarationConstants.NOT_FOUND_MESSAGE}
      </Typography>
      <Button variant="contained" onClick={() => naviagte('/')}>
        {DeclarationConstants.GO_HOME}
      </Button>
    </div>
  );
};

export default PageNotFoundView;
